<template>
  <v-card>
    <v-card-title class="primary">
    	<h3 style="font-size: 18px; color: #FFF; font-weight: 500">Filtro de Endossos</h3>
    </v-card-title>
    <v-card-text class="px-4">
      <v-form ref="formFiltro">
        <v-select
          v-model="filtroModel.listaIdStatusEndosso"
          :items="endossoStatusList"
          placeholder="Selecione uma opção"
          label="Status do Endosso"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdStatusEndosso.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensStatusEndosso">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosStatusEndosso }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-autocomplete
          v-model="filtroModel.listaIdTecnicoResponsavelEndosso"
          :items="tecnicoResponsavelList"
          :filter="filtrarTecnicoResponsavel"
          placeholder="Digite para pesquisar"
          label="Tecnico Responsável do Endosso"
          item-value="id"
          item-text="nome"
          no-data-text="Nenhum técnico encontrado"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.nome }} </span>
            <span v-if="index === 1">,&nbsp{{ item.nome }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdTecnicoResponsavelEndosso.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensTecnicoResponsavel">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosTecnicoResponsavel }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
        <v-select
          v-model="filtroModel.listaIdTipoEndosso"
          :items="tipoEndossoList"
          placeholder="Selecione uma opção"
          label="Tipo do Endosso"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdTipoEndosso.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensTipoEndosso">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosTipoEndosso }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.listaIdTipoCobertura"
          :items="tipoCoberturaList"
          placeholder="Selecione uma opção"
          label="Tipo de Cobertura"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdTipoCobertura.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensTipoCobertura">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosTipoCobertura }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-text-field
          v-model="filtroModel.numeroEndossoEssor"
          label="Nº Endosso Essor"
          placeholder="Informe o número do endosso Essor"
          clearable
        ></v-text-field>
        <v-text-field
          v-model="filtroModel.numeroCotacaoEndosso"
          label="Nº Cotação Endosso"
          placeholder="Informe o número da cotação do endosso"
          clearable
        ></v-text-field>
      </v-form>
    </v-card-text>
	<v-divider></v-divider>
	<v-card-actions class="px-4">
		<v-layout row wrap>
			<v-flex md12 xs12>
				<v-btn color="primary" block @click="tratamentoFiltrarItens" :disabled="desabilitarBotaoFiltrar">
					Filtrar
				</v-btn>
				<div class="special-flex-filtro">
					<v-btn color="secondary" flat @click="tratamentoFecharModalFiltro">
						Fechar
					</v-btn>

					<v-btn color="secondary" flat @click="tratamentoLimparFiltro">
						Limpar
					</v-btn>
				</div>
			</v-flex>
		</v-layout>
	</v-card-actions>
  </v-card>
</template>
<script>
import CustomFormat from "@/helpers/custom-format";

export default {
  name: "ModalFiltroEndosso",
  props: {
    endossoStatusList: {
      type: Array,
      required: false
    },
    tecnicoResponsavelList: {
      type: Array,
      required: false
    },
    filtroAtivado: {
      type: Boolean,
      required: true,
    },
    dadosFiltroAtivado: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      filtroModel: {
        listaIdStatusEndosso: [],
        listaIdTecnicoResponsavelEndosso: [],
        listaIdTipoEndosso: [],
        listaIdTipoCobertura: [],
        numeroEndossoEssor: null,
        numeroCotacaoEndosso: null,
      },
      tipoEndossoList: [
        { id: 1, titulo: 'COBRANÇA' },
        { id: 2, titulo: 'RESTITUIÇÃO' },
        { id: 3, titulo: 'EXCLUSÃO' },
        { id: 4, titulo: 'CANCELAMENTO' },
        { id: 5, titulo: 'SUBSTITUIÇÃO' },
        { id: 6, titulo: 'ALTERAÇÃO' },
        { id: 7, titulo: 'GATILHO' },
      ],
      tipoCoberturaList: [
        { id: 1, titulo: 'COMPREENSIVA' },
        { id: 2, titulo: 'INCÊNDIO E ROUBO' },
        { id: 3, titulo: 'RCF' },
      ],
    };
  },
  mounted() {
    if (this.dadosFiltroAtivado && Object.keys(this.dadosFiltroAtivado).length > 0) {
      this.filtroModel = {
        listaIdStatusEndosso: this.dadosFiltroAtivado.listaIdStatusEndosso || [],
        listaIdTecnicoResponsavelEndosso: this.dadosFiltroAtivado.listaIdTecnicoResponsavelEndosso || [],
        listaIdTipoEndosso: this.dadosFiltroAtivado.listaIdTipoEndosso || [],
        listaIdTipoCobertura: this.dadosFiltroAtivado.listaIdTipoCobertura || [],
        numeroEndossoEssor: this.dadosFiltroAtivado.numeroEndossoEssor || null,
        numeroCotacaoEndosso: this.dadosFiltroAtivado.numeroCotacaoEndosso || null,
      };
    }
  },
  watch: {
    dadosFiltroAtivado(val) {
      this.filtroModel = {
        listaIdStatusEndosso: (val && val.listaIdStatusEndosso) ? [...val.listaIdStatusEndosso] : [],
        listaIdTecnicoResponsavelEndosso: (val && val.listaIdTecnicoResponsavelEndosso) ? [...val.listaIdTecnicoResponsavelEndosso] : [],
        listaIdTipoEndosso: (val && val.listaIdTipoEndosso) ? [...val.listaIdTipoEndosso] : [],
        listaIdTipoCobertura: (val && val.listaIdTipoCobertura) ? [...val.listaIdTipoCobertura] : [],
        numeroEndossoEssor: (val && val.numeroEndossoEssor) ? val.numeroEndossoEssor : null,
        numeroCotacaoEndosso: (val && val.numeroCotacaoEndosso) ? val.numeroCotacaoEndosso : null,
      };
    }
  },
  computed: {
    validaFormFiltro() {
      return this.filtroModel.listaIdStatusEndosso.length > 0 ||
        this.filtroModel.listaIdTecnicoResponsavelEndosso.length > 0 ||
        this.filtroModel.listaIdTipoEndosso.length > 0 ||
        this.filtroModel.listaIdTipoCobertura.length > 0 ||
        !!this.filtroModel.numeroEndossoEssor ||
        !!this.filtroModel.numeroCotacaoEndosso
    },
    desabilitarBotaoFiltrar() {
      return !this.validaFormFiltro;
    },
    igualUmItemStatusEndosso() {
      return (
        this.filtroModel.listaIdStatusEndosso.length > 0 && !this.igualTodosItensStatusEndosso
    	);
    },
    igualTodosItensStatusEndosso() {
      return this.filtroModel.listaIdStatusEndosso.length === this.endossoStatusList.length;
    },
    iconeSelecionarTodosStatusEndosso() {
      if (this.igualTodosItensStatusEndosso) return "check_box";
      if (this.igualUmItemStatusEndosso) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualUmItemTecnicoResponsavel() {
      return (
        this.filtroModel.listaIdTecnicoResponsavelEndosso.length > 0 && !this.igualTodosItensTecnicoResponsavel
    	);
    },
    igualTodosItensTecnicoResponsavel() {
      return this.filtroModel.listaIdTecnicoResponsavelEndosso.length === this.tecnicoResponsavelList.length;
    },
    iconeSelecionarTodosTecnicoResponsavel() {
      if (this.igualTodosItensTecnicoResponsavel) return "check_box";
      if (this.igualUmItemTecnicoResponsavel) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualUmItemTipoEndosso() {
      return (
        this.filtroModel.listaIdTipoEndosso.length > 0 && !this.igualTodosItensTipoEndosso
    	);
    },
    igualTodosItensTipoEndosso() {
      return this.filtroModel.listaIdTipoEndosso.length === this.tipoEndossoList.length;
    },
    iconeSelecionarTodosTipoEndosso() {
      if (this.igualTodosItensTipoEndosso) return "check_box";
      if (this.igualUmItemTipoEndosso) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualUmItemTipoCobertura() {
      return (
        this.filtroModel.listaIdTipoCobertura.length > 0 && !this.igualTodosItensTipoCobertura
    	);
    },
    igualTodosItensTipoCobertura() {
      return this.filtroModel.listaIdTipoCobertura.length === this.tipoCoberturaList.length;
    },
    iconeSelecionarTodosTipoCobertura() {
      if (this.igualTodosItensTipoCobertura) return "check_box";
      if (this.igualUmItemTipoCobertura) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
  },
  methods: {
    filtrarTecnicoResponsavel(item, queryText) {
      if (!queryText) return true;
      const nome = CustomFormat.removerAcentos(item.nome || "");
      const busca = CustomFormat.removerAcentos(queryText);
      return nome.includes(busca);
    },
    tratamentoLimparFiltro() {
      this.$emit('formFiltroLimpo', true);
      this.limparFormFiltro();
    },
    selecionarTodosItensStatusEndosso() {
    	this.$nextTick(() => {
        if (this.igualTodosItensStatusEndosso) {
          this.filtroModel.listaIdStatusEndosso = [];
        } else {
          const listagemItens = this.endossoStatusList.slice();
          this.filtroModel.listaIdStatusEndosso = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdStatusEndosso.push(listagemItem.id);
          }
        }
      });
    },
    selecionarTodosItensTecnicoResponsavel() {
    	this.$nextTick(() => {
        if (this.igualTodosItensTecnicoResponsavel) {
          this.filtroModel.listaIdTecnicoResponsavelEndosso = [];
        } else {
          const listagemItens = this.tecnicoResponsavelList.slice();
          this.filtroModel.listaIdTecnicoResponsavelEndosso = [];
          for (var item of listagemItens) {
            this.filtroModel.listaIdTecnicoResponsavelEndosso.push(item.id);
          }
        }
      });
    },
    selecionarTodosItensTipoEndosso() {
    	this.$nextTick(() => {
        if (this.igualTodosItensTipoEndosso) {
          this.filtroModel.listaIdTipoEndosso = [];
        } else {
          const listagemItens = this.tipoEndossoList.slice();
          this.filtroModel.listaIdTipoEndosso = [];
          for (var itemTipoEndosso of listagemItens) {
            this.filtroModel.listaIdTipoEndosso.push(itemTipoEndosso.id);
          }
        }
      });
    },
    selecionarTodosItensTipoCobertura() {
    	this.$nextTick(() => {
        if (this.igualTodosItensTipoCobertura) {
          this.filtroModel.listaIdTipoCobertura = [];
        } else {
          const listagemItens = this.tipoCoberturaList.slice();
          this.filtroModel.listaIdTipoCobertura = [];
          for (var itemTipoCobertura of listagemItens) {
            this.filtroModel.listaIdTipoCobertura.push(itemTipoCobertura.id);
          }
        }
      });
    },
    tratamentoFiltrarItens() {
      this.$emit('filtrarDadosModal', this.filtroModel);
      sessionStorage.setItem(
        "filtroEndossoObjetoString",
        JSON.stringify(this.filtroModel)
      );
      this.$emit('fecharModalFiltro');
    },
    tratamentoFecharModalFiltro() {
      this.$emit('fecharModalFiltro');
      if (!this.filtroAtivado) {
        this.limparFormFiltro();
      }
    },
    limparFormFiltro() {
      this.filtroModel = {
        listaIdStatusEndosso: [],
        listaIdTecnicoResponsavelEndosso: [],
        listaIdTipoEndosso: [],
        listaIdTipoCobertura: [],
        numeroEndossoEssor: null,
        numeroCotacaoEndosso: null,
      };
      if (this.$refs.formFiltro) {
        this.$refs.formFiltro.reset();
        this.$refs.formFiltro.resetValidation();
      }
    }
  }
};
</script>

<style>
  .special-flex-filtro {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalFiltroEndosso.vue